import React, {
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { notification } from 'antd';

import LogSyncDetailsContext from '@totem/components/administration/logSync/details/LogSyncDetailsContext';
import { LogSyncDetail } from '@totem/components/administration/logSync/details/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { LOG_SYNC_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  logSyncId: string;
  children?: ReactNode;
};

const LogSyncDetailsContainer = ({ logSyncId, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [loading, setLoading] = useState<boolean>(true);
  const [detail, setDetail] = useState<LogSyncDetail | null>(null);
  const [refreshData, setRefreshData] = useState<boolean>(true);

  useEffect(() => {
    if (!refreshData || !logSyncId) {
      return;
    }

    setRefreshData(false);

    setLoading(true);

    fetch(`${LOG_SYNC_ENDPOINT}/${logSyncId}`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: LogSyncDetail) => {
        setDetail(result ?? null);
      })
      .catch(() => {
        notification.error({ message: 'Failed to load log sync result.' });
      })
      .finally(() => setLoading(false));
  }, [refreshData, logSyncId, getApiToken]);

  const onRefresh = useCallback(() => {
    setRefreshData(true);
  }, []);

  return (
    <LogSyncDetailsContext.Provider value={{ loading, detail, onRefresh }}>
      {children}
    </LogSyncDetailsContext.Provider>
  );
};

export default LogSyncDetailsContainer;
